if (!customElements.get('mobile-product-content')) {
  class MobileProductContent extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const coco = this.closest('coco-shuffle');
      const read_reviews = [...coco.querySelectorAll('[data-read-reviews]')];

      const observer = new MutationObserver((mutations) => {
        mutations.forEach(() => {
          const pr_snippet = coco.querySelector('.pr-snippet');

          if (pr_snippet) {
            observer.disconnect();
            const star_ratings = pr_snippet.querySelector('.pr-rating-stars');
            const ratings = pr_snippet.querySelector('.pr-snippet-rating-count').innerHTML;
            const ratings_count = ratings.toLowerCase().includes('no ratings') ? 0 : ratings.match(/\d+/)[0];

            if (ratings_count === 0) {
              read_reviews.forEach(el => el.classList.add('hidden'));
            } else {
              const reviews_html = `
                ${star_ratings.outerHTML}
                <div class="!text-xxs md:!text-xs">(${ratings_count})
                  <a class="!underline !text-black" href="#pr-reviewdisplay">Read Reviews</a>
                </div>
              `;
              read_reviews.forEach(el => el.innerHTML = reviews_html);
            }
          }
        })
      });

      observer.observe(coco, { childList: true, subtree: true });
    }
  }
  customElements.define('mobile-product-content', MobileProductContent);
}
